import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../castle-kit';
import * as g from '../../castle-kit-grounds';

/**
 * TRAINING YARD (Тренировочный двор) — the castle's OPEN-AIR martial practice yard: dusty, sparse, the
 * one place GREEN is allowed (two corner pines mark it as a walled court). The HERO is the line of
 * ARMOURED PELLS — two suits of armour lashed to posts as sparring dummies, each shouldered by a
 * stacked-barrel STRAW TARGET, with a WEAPON RACK crowning the line so the eye reads "practice ground"
 * instantly. Twin heraldic banners frame that strip. A central WELL is the gather + cool-down beat; rail
 * benches on the flanks let ducks rest, lit by a pair of lampposts. The lower yard is deliberately OPEN —
 * dust and breathing room, not clutter — so all the eye's weight stays on the pell line.
 *
 * Geometry: zone (40,1180) 760×520 → centre (420,1440). Doors on the N wall (x420), the S wall (x420)
 * and the E wall (y1440) are kept clear — set-dressing hugs the walls + the pell line, central cross open.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;

  // ── Corner PINES — the only green on the map's interior, marking this as a walled OUTDOOR court. ──
  place(ctx, g.tree(art, 'pine'), 120, 1240);
  place(ctx, g.tree(art, 'pine'), 720, 1240);

  // ── Twin heraldic BANNERS on poles framing the top of the pell line. ──
  place(ctx, kit.banner(art, undefined, 110), 250, 1240);
  place(ctx, kit.banner(art, 0x8a2f2f, 110), 560, 1240);

  // ── The WEAPON RACK crowning the pell line (the practice arms). ──
  place(ctx, kit.weaponRack(art), 420, 1230);

  // ── HERO: the ARMOURED PELLS — two suits of armour as sparring dummies, each shouldered by a
  //    stacked-barrel STRAW TARGET so the strip reads as a busy line of practice marks. ──
  place(ctx, kit.suitOfArmour(art), 250, 1320);
  place(ctx, kit.suitOfArmour(art), 560, 1320);
  place(ctx, kit.barrelStack(art), 175, 1330); // straw target beside the west pell
  place(ctx, kit.barrelStack(art), 635, 1330); // straw target beside the east pell

  // ── The WELL — central cool-down beat, just south of the open cross so the lane stays clear. ──
  place(ctx, g.well(art), 420, 1500);

  // ── REST RAIL benches along the flanks (a place to catch your breath between bouts). ──
  place(ctx, g.gardenBench(art, 96), 120, 1620);
  place(ctx, g.gardenBench(art, 96), 720, 1620);

  // ── LAMPPOSTS pooling warm light onto the active strip + the rest rails — the yard's bright beat. ──
  place(ctx, g.lamppost(art), 120, 1440);
  place(ctx, g.lamppost(art), 720, 1440);
};

export default decorate;
